(() => {
const $17a4f721f82c4240$var$getViewportWidth = ()=>{
    return document.querySelector('html').clientWidth;
};
const $17a4f721f82c4240$var$setDecorativeMaxWidth = ()=>{
    $17a4f721f82c4240$var$decorativeElements.forEach((el)=>{
        const enclosingSectionRect = el.closest('section').getBoundingClientRect();
        el.style.setProperty('--max-width', `${($17a4f721f82c4240$var$getViewportWidth() - enclosingSectionRect.width) / 2}px`);
    });
};
const $17a4f721f82c4240$var$decorativeElements = document.querySelectorAll('.decorative-element');
if ($17a4f721f82c4240$var$decorativeElements.length) {
    $17a4f721f82c4240$var$setDecorativeMaxWidth();
    window.addEventListener('resize', $17a4f721f82c4240$var$setDecorativeMaxWidth);
}

})();
//# sourceMappingURL=highlight.min.js.map
